// =============================================================================
// MeuDriver — OfflineBanner
// -----------------------------------------------------------------------------
// Banner fixo no topo que aparece quando o navegador detecta perda de conexão
// (`navigator.onLine === false`). Some automaticamente quando a conexão volta.
//
// Renderizado uma única vez no topo de <App>, fora do Routes para evitar
// flicker em troca de rota.
// =============================================================================

import { useEffect, useState } from 'react'
import { WifiOff } from 'lucide-react'

function isOffline(): boolean {
  // SSR-safe: assume online quando window não existe
  if (typeof navigator === 'undefined') return false
  return navigator.onLine === false
}

export function OfflineBanner() {
  const [offline, setOffline] = useState<boolean>(() => isOffline())

  useEffect(() => {
    function onOnline() { setOffline(false) }
    function onOffline() { setOffline(true) }

    window.addEventListener('online', onOnline)
    window.addEventListener('offline', onOffline)

    return () => {
      window.removeEventListener('online', onOnline)
      window.removeEventListener('offline', onOffline)
    }
  }, [])

  if (!offline) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-0 z-[200] bg-amber-500 text-amber-950 shadow-md"
    >
      <div className="max-w-5xl mx-auto px-4 py-2 flex items-center gap-2 text-sm font-medium">
        <WifiOff className="h-4 w-4 shrink-0" />
        <span>
          Sem conexão. Algumas ações ficarão indisponíveis até a internet voltar.
        </span>
      </div>
    </div>
  )
}
